if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      /*
       * BM Figma mobile footer: every `<details>` in the footer (menus,
       * contact info, image_text) stays expanded on every breakpoint —
       * no disclosure behaviour. The theme's default was to call
       * `this.open = false` on tablet/mobile unless `openDefault` was
       * true, which ran `animateAccordion(false)` in theme.js:1013 and
       * faded the content element to `opacity: 0` via Web Animations.
       * That animation wins over CSS `!important`, so menu links were
       * rendered invisible on mobile even with our force-open CSS.
       *
       * We now force `open = true` at every breakpoint and on every
       * match/unmatch event so the content never collapses. The
       * `.footer-accordion-details > summary { pointer-events: none }`
       * rule in bm-overrides.css (inside the ≤767.98px media query)
       * prevents users from manually closing it again. Desktop is
       * unchanged because it previously also forced open on unmatch.
       */
      this.open = true;

      document.addEventListener('matchTablet', () => {
        this.open = true;
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
